/* ───────────────  index.js  ─────────────── */

/* 1. ️⃣  ОБЯЗАТЕЛЬНО все импорты наверху (ES-lint import/first) */
import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import RouterApp from './App';

/* 2. 🔇  «Мягкий» фильтр шумных warning’ов - оставляем только в DEV */
if (process.env.NODE_ENV !== 'production') {
  const patterns = [
    'Alpha-premult and y-flip are deprecated',
    'texSubImage',
    "Couldn't find terrain source",
    'featureNamespace place-A',
    'Cutoff is currently disabled on terrain'
  ];

  const originalWarn = console.warn;
  // eslint-disable-next-line no-console
  console.warn = (...args) => {
    const msg = args[0];
    if (typeof msg === 'string' && patterns.some(p => msg.includes(p))) return;
    originalWarn(...args);
  };
}

/* 3. (не трогаем setLogLevel — в mapbox-gl v2.x этой функции нет) */

/* 4. 🚀  Рендер приложения */
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <RouterApp />
  </React.StrictMode>
);
